<template>
  <ContentPage>
    <v-list class="mt-2 py-0 rounded-lg">
      <MenuItem title="Account" :to="{ name: 'you/profile' }" />

      <v-divider/>

      <MenuItem title="Users" :to="{ name: 'you/users' }" />

      <v-divider/>

      <MenuItem title="Your Lead Preferences" :to="{ name: 'you/services' }" />

      <v-divider/>

      <MenuItem title="Legal" :to="{ name: 'you/legal' }" />
      
      <v-divider/>

      <MenuItem title="Support" :to="{ name: 'you/support' }" />

      <v-divider/>

      <MenuItem title="Password" :to="{ name: 'you/password' }" />

      <v-divider/>

      <MenuItem title="Logout" @click="logoutClick" />
    </v-list>
  </ContentPage>
</template>

<script>
import { ContentPage, MenuItem } from '@/components/pages'
import { mapActions } from 'vuex'

export default {
  components: { ContentPage, MenuItem },

  methods: {
    ...mapActions('auth', ['logout']),

    logoutClick() {
      this.logout()
      this.$router.push( { name: 'login' })
    }
  },
}
</script>